"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSocialYoutube = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconSocialYoutube = function IconSocialYoutube(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.336 3.501c1.486.007 7.41.063 9.041.502a3.032 3.032 0 012.126 2.15c.458 1.72.494 5.139.497 5.746v.136c-.002.43-.03 4.027-.504 5.804a3.05 3.05 0 01-2.126 2.151c-.836.228-2.796.354-4.71.424l-.544.018a150.61 150.61 0 01-3.965.068h-.31c-1.081-.004-7.507-.043-9.212-.503a3.035 3.035 0 01-2.126-2.15c-.458-1.72-.5-5.145-.504-5.753v-.188c.004-.608.045-4.032.497-5.753A3.024 3.024 0 012.622 4.01c1.632-.445 7.55-.502 9.034-.509zM9.592 8.356v7.288L15.84 12 9.592 8.356z"
  }));
};
exports.IconSocialYoutube = IconSocialYoutube;